export enum TabQueryParam {
  General = 'general',
  Production = 'production',
  Mobile = 'mobile',
}
